export var ACTION;
(function (ACTION) {
    ACTION["NAVIGATION_SEARCH_IFSC"] = "NAVIGATION_SEARCH_IFSC";
    ACTION["ONCHANGE_ACCOUNT_NUMBER"] = "ONCHANGE_ACCOUNT_NUMBER";
    ACTION["ONCHANGE_IFSC_NUMBER"] = "ONCHANGE_IFSC_NUMBER";
    ACTION["TRIGGER_CTA"] = "TRIGGER_CTA";
    ACTION["TOGGLE_CTA"] = "TOGGLE_CTA";
    ACTION["CHANGE_BANK_GO_BACK"] = "CHANGE_BANK_GO_BACK";
    ACTION["NAV_STEPPER"] = "NAV_STEPPER";
    ACTION["GO_TO_NEXT"] = "GO_TO_NEXT";
    ACTION["SKIP_BANK"] = "SKIP_BANK";
    ACTION["GO_TO_BANK_ACCOUNT_ADD"] = "GO_TO_BANK_ACCOUNT_ADD";
    ACTION["NEED_HELP"] = "NEED_HELP";
})(ACTION || (ACTION = {}));
